(function () {
  'use strict';
  if (window.sn17CollectionLoaded) return;
  window.sn17CollectionLoaded = true;
  function readJSON(card, selector, fallback) {
    try { return JSON.parse(card.querySelector(selector).textContent); }
    catch (error) { return fallback; }
  }
  function initCard(card) {
    if (card.dataset.sn17Ready) return;
    card.dataset.sn17Ready = 'true';
    var variants = readJSON(card, '[data-card-variants]', []);
    var mediaMap = readJSON(card, '[data-card-media-map]', {});
    var image = card.querySelector('[data-card-image]');
    var placeholder = card.querySelector('[data-card-placeholder]');
    var price = card.querySelector('[data-card-price]');
    var colourLabel = card.querySelector('[data-card-colour-label]');
    var announcement = card.querySelector('[data-card-announcement]');
    function responsiveURL(source, width) {
      try {
        var url = new URL(source, window.location.href);
        var shopifyFile = url.hostname === 'cdn.shopify.com' || (url.origin === window.location.origin && url.pathname.indexOf('/cdn/shop/') === 0);
        if (!shopifyFile) return null;
        url.searchParams.set('width', String(width));
        return url.href;
      } catch (error) { return null; }
    }
    function setImage(variant) {
      if (!image) return;
      var media = mediaMap[String(variant.id)] || [];
      var studio = media.find(function (item) { return item.role === 'studio'; });
      var source = studio && studio.src ? studio.src : variant.fallback;
      if (!source) {
        image.hidden = true;
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        if (placeholder) placeholder.hidden = false;
        return;
      }
      image.hidden = false;
      image.alt = studio && studio.alt ? studio.alt : card.dataset.productTitle + ' — ' + variant.title;
      var resized = responsiveURL(source, 640);
      if (resized) {
        if (!image.sizes) image.sizes = '(min-width: 990px) 25vw, 50vw';
        image.srcset = [240, 360, 480, 640, 960].map(function (width) {
          return responsiveURL(source, width) + ' ' + width + 'w';
        }).join(', ');
      } else image.removeAttribute('srcset');
      if (studio && studio.width > 0 && studio.height > 0) {
        image.width = studio.width;
        image.height = studio.height;
      }
      image.onerror = function () {
        image.removeAttribute('srcset');
        image.onerror = function () {
          image.onerror = null;
          image.hidden = true;
          if (placeholder) placeholder.hidden = false;
        };
        if (variant.fallback && image.getAttribute('src') !== variant.fallback) {
          image.src = variant.fallback;
        } else {
          image.onerror = null;
          image.hidden = true;
          if (placeholder) placeholder.hidden = false;
        }
      };
      var displayedSource = resized || source;
      if (image.getAttribute('src') !== displayedSource) image.src = displayedSource;
      if (placeholder) placeholder.hidden = true;
    }
    function selectVariant(id, announce) {
      var variant = variants.find(function (item) { return String(item.id) === String(id); });
      if (!variant) return;
      card.dataset.variant = String(variant.id);
      card.querySelectorAll('[data-card-link]').forEach(function (link) { link.href = variant.url; });
      card.querySelectorAll('[data-card-swatch]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.value === String(variant.id)));
      });
      var colourSelect = card.querySelector('[data-card-select]');
      if (colourSelect) colourSelect.value = String(variant.id);
      if (colourLabel) colourLabel.textContent = variant.title;
      if (price) {
        price.dataset.priceCents = String(variant.price);
        try {
          price.textContent = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: card.dataset.currency || 'EUR'
          }).format(Number(variant.price) / 100);
        } catch (error) { price.textContent = (Number(variant.price) / 100).toFixed(2).replace('.', ',') + ' €'; }
      }
      setImage(variant);
      if (announce && announcement) announcement.textContent = variant.title + ' sélectionné, ' + (price ? price.textContent : '');
      card.dispatchEvent(new CustomEvent('sn17:card-variant-change', { bubbles: true, detail: { variant: variant } }));
    }
    card.addEventListener('click', function (event) {
      var button = event.target.closest('[data-card-swatch]');
      if (!button || !card.contains(button)) return;
      event.preventDefault();
      selectVariant(button.value, true);
    });
    var colourSelect = card.querySelector('[data-card-select]');
    if (colourSelect) {
      colourSelect.addEventListener('change', function () { selectVariant(colourSelect.value, true); });
    }
    selectVariant(card.dataset.variant, false);
  }
  function init(root) {
    root.querySelectorAll('[data-sn17-card]').forEach(initCard);
    root.querySelectorAll('[data-sn17-sort]').forEach(function (select) {
      if (select.dataset.sn17Ready) return;
      select.dataset.sn17Ready = 'true';
      select.addEventListener('change', function () { select.form.requestSubmit(); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.sn17-collection__filter-group[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sn17-collection__filter-group[open]').forEach(function (details) {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
}());
